<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail JALA Ponds",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_ponds.singular')) }},
    resourceRoute: {default: 'jala_ponds'},
    modelVariable: {default: 'jala_pond'},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_ponds.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_ponds.plural')),
          href: "/jala_ponds",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/jala_ponds/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.farm`)),
        item: this.model.farm,
        value: {
          props: { item: { type: Object, default() { return {} } } },
          template: '<router-link :to="`/jala_farms/${item.id}`">{{ lodash.get(item, "name") }}</router-link>'
        }
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.name`)),
        value: this.model.name,
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.area`)),
        value: this.$numeral(this.model.area).format('0,0'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.length`)),
        value: this.$numeral(this.model.length).format('0,0'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.width`)),
        value: this.$numeral(this.model.width).format('0,0'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.deep`)),
        value: this.$numeral(this.model.deep).format('0,0'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.feeding_tray_count`)),
        value: this.$numeral(this.model.feeding_tray_count).format('0,0'),
      }]
    }
  },
  methods: {
    delete() {
      return this.$axios.delete(`/jala/ponds/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/jala/ponds/${this.$route.params.key}`, {
        params: { with: 'farm' }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    }
  }
}
</script>
